/**
 * Backend-agnostic mesher worker client (Phase 6.5 step 5b prep).
 *
 * Both the WebGL renderer (`renderer/viewer/three/`) and the WebGPU
 * renderer (`renderer/viewer/webgpu/`) need to spawn mesher workers and
 * push MC data into them. Originally these helpers lived in
 * `worldrendererCommon.ts` but importing from there transitively pulls
 * `import * as THREE from 'three'` — which would force the WebGPU bundle
 * to also load the WebGL three.js (dup namespace).
 *
 * This module has NO THREE dependency. It's safe to import from any
 * backend codebase.
 */

import mcDataRaw from 'minecraft-data/data.js' // alias
import { dynamicMcDataFiles } from '../../buildMesherConfig.mjs'
import { toMajorVersion } from '../../../src/utils'

export const initMesherWorker = (onGotMessage: (data: any) => void): Worker => {
  const workerName = 'mesher.js'
  let worker: any
  if (process.env.SINGLE_FILE_BUILD) {
    const workerCode = document.getElementById('mesher-worker-code')!.textContent!
    const blob = new Blob([workerCode], { type: 'text/javascript' })
    worker = new Worker(window.URL.createObjectURL(blob))
  } else {
    worker = new Worker(workerName)
  }
  worker.onmessage = ({ data }: MessageEvent) => onGotMessage(data)
  if (worker.on) worker.on('message', (data: any) => { worker.onmessage({ data }) })
  return worker as Worker
}

export const meshersSendMcData = (
  workers: Worker[],
  version: string,
  addData: Record<string, any> = {}
) => {
  const allMcData = (mcDataRaw as any).pc[version] ?? (mcDataRaw as any).pc[toMajorVersion(version)]
  const mcData: Record<string, any> = {
    version: JSON.parse(JSON.stringify(allMcData.version)),
  }
  for (const key of dynamicMcDataFiles) {
    mcData[key] = allMcData[key]
  }
  for (const worker of workers) {
    worker.postMessage({ type: 'mcData', mcData, ...addData })
  }
}
